import { ApexOptions } from 'apexcharts';

import { TrapType } from 'components/AnalyticsPage/TrapType';
import { TFunction } from 'i18next';

interface ChartData {
  date: string[];
  mct_count?: number[];
  smst_count?: number[];
  srst_count?: number[];
}

interface SeriesType {
  name: string;
  data: number[];
}

export const trapActivityLineChartOptions = (
  chartData: ChartData,
  t: TFunction,
  isMobile: boolean,
  showTraps: TrapType,
  isBarChart: boolean,
  title?: string,
  zoom?: boolean,
) => {
  const series: SeriesType[] = [];

  if (showTraps === TrapType.MCT) {
    series.push({
      name: t('ChartsAnalitics.all_traps_captures.data_labels_mct'),
      data: chartData.mct_count || [],
    });
  } else if (showTraps === TrapType.SMST) {
    series.push({
      name: t('ChartsAnalitics.all_traps_captures.data_labels_smst'),
      data: chartData.smst_count || [],
    });
  } else if (showTraps === TrapType.SRST) {
    series.push({
      name: t('ChartsAnalitics.all_traps_captures.data_labels_srst'),
      data: chartData.srst_count || [],
    });
  } else {
    series.push(
      {
        name: t('ChartsAnalitics.all_traps_captures.data_labels_mct'),
        data: chartData.mct_count || [],
      },
      {
        name: t('ChartsAnalitics.all_traps_captures.data_labels_smst'),
        data: chartData.smst_count || [],
      },
    );
  }

  const chartOptions: ApexOptions = {
    series: series,
    chart: {
      height: 350,
      type: isBarChart ? 'bar' : 'area',
      zoom: {
        enabled: zoom,
      },
      toolbar: {
        show: !title,
      },
      stacked: isBarChart,
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
    },
    dataLabels: {
      enabled: !isBarChart,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        columnWidth: '50%',
        barHeight: '80%',
        isDumbbell: true,
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: '13px',
              fontWeight: 500,
              color: '#4f555c',
            },
          },
        },
      },
    },
    fill: isBarChart
      ? {
          type: 'solid',
          opacity: 1,
        }
      : {
          type: 'gradient',
        },
    markers: {
      size: 3,
      shape: 'circle',
    },
    legend: {
      show: isMobile && isBarChart && false,
      position: isBarChart ? 'right' : 'bottom',
    },
    stroke: {
      show: !isBarChart,
      width: [3, 3],
      curve: ['smooth', 'smooth'],
    },
    xaxis: {
      title: {
        text: t('ChartsAnalitics.all_traps_captures.x_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
      categories: chartData.date || [],
      type: 'category',
      tickPlacement: 'on',
    },
    yaxis: {
      stepSize: 2,
      decimalsInFloat: 0,
      title: {
        text: t('ChartsAnalitics.all_traps_captures.y_axis_title'),
        style: {
          fontSize: '12px',
        },
      },
    },
    colors: ['#6A37D4', '#FFE529'],
    ...(title
      ? {
          title: {
            text: title,
            align: 'center',
            style: {
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#000',
            },
          },
        }
      : {}),
  };

  return chartOptions;
};
